import React from 'react';

import TextInput from './input';
import TextArea from './textarea';
import { sendContactMessage } from '../../services';
import { trackAdWordsConversion } from '../../../../services/adWords';
import { trackAnalyticsEvent } from '../../../../services/analytics';
import { Validate } from '../../../../../../common/validation/validate';
import { T } from '../../../../../../common/locale/translate';

let isValid = true;

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      email: '',
      phoneNumber: '',
      message: '',
      isNewsletterCheckboxChecked: false,

      fullNameClass: '',
      lastNameClass: '',
      emailClass: '',
      phoneNumberClass: '',
      messageClass: '',

      formMessageVisibility: 'hidden',
      formMessage: '',
      valid: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  render = () => (
    <div className="form">
      <TextInput
        label={'*' + T('full_name')}
        name="fullName"
        class={this.state.fullNameClass}
        id="contactName"
        onChangeCallback={this.handleChange}
        validationMessage={T('full_name_notification')}
        ref="full_name"
      />
      <TextInput
        label={'*' + T('email_address')}
        name="email"
        type="email"
        class={this.state.emailClass}
        id="contactEmail"
        onChangeCallback={this.handleChange}
        validationMessage={T('email_notification')}
        ref="email_address"
      />
      <TextInput
        label={'*' + T('phone_number')}
        name="phoneNumber"
        class={this.state.phoneNumberClass}
        id="contactPhone"
        onChangeCallback={this.handleChange}
        validationMessage={T('phone_number_notification')}
        ref="phone_number"
      />
      <TextArea
        label={'*' + T('message_content')}
        name="message"
        class={this.state.messageClass}
        id="contactMessage"
        onChangeCallback={this.handleChange}
        validationMessage={T('message_content_notification')}
        ref="message"
      />
      {this.checkbox()}
      <button onClick={this.handleSubmit}>{T('send_message')}</button>
      <div className={'form-message ' + this.state.formMessageVisibility}>
        {this.state.formMessage}
      </div>
    </div>
  );

  checkbox = () => (
    <div className="checkbox-wrapper">
      <input
        type="checkbox"
        className="filled-in"
        id="subscribe-to-newsletter"
        checked={this.state.isNewsletterCheckboxChecked}
        onChange={this.handleCheckboxChange}
      />
      <label htmlFor="subscribe-to-newsletter">
        {' '}
        {T('sign_to_newsletter')}{' '}
      </label>
      {this.state.isNewsletterCheckboxChecked && (
        <span className="newsletter-confirmation-mail-information">
          {T('newsletter_after_sign_up')}
        </span>
      )}
    </div>
  );

  handleCheckboxChange() {
    this.setState({
      isNewsletterCheckboxChecked: this.state.isNewsletterCheckboxChecked
        ? false
        : true
    });
  }

  handleChange(inputName, inputValue) {
    this.setState({ [inputName]: inputValue });
  }

  handleSubmit() {
    isValid = true;

    this.validateField('fullName');
    this.validateField('email');
    this.validateField('phoneNumber');
    this.validateField('message');

    if (!isValid) {
      return;
    }

    const messageData = this.messageData();

    trackAdWordsConversion(715672677, 'HxRyCMfS93EQrZTnlwM');
    trackAnalyticsEvent(
      'kontakt z biurem',
      'formularz',
      'formularz na stronie kontaktu'
    );

    if (messageData.subscribeNewsletter) {
      trackAnalyticsEvent(
        'newsletter',
        'zapis do newslettera',
        'zapis przez formularz kontaktowy'
      );
    }

    sendContactMessage(messageData)
      .then(response => {
        let message = response.data.message;
        this.setState({
          formMessage: message,
          formMessageVisibility: 'visible'
        });
        this.resetForm();
      })
      .catch(error => {
        let message = error.response.data.message;
        this.setState({
          formMessage: message,
          formMessageVisibility: 'visible'
        });
      });
  }

  validateField = fieldName => {
    let fieldValue = this.state[fieldName];

    if (!Validate.byType(fieldName, fieldValue)) {
      this.setState({
        [fieldName + 'Class']: 'invalid'
      });
      isValid = false;
    } else {
      this.setState({ [fieldName + 'Class']: '' });
    }
  };

  messageData = () => {
    let messageToSend = {
      fullName: this.state.fullName,
      email: this.state.email,
      phoneNumber: this.state.phoneNumber,
      message: this.state.message,
      subscribeNewsletter: this.state.isNewsletterCheckboxChecked
    };
    return messageToSend;
  };

  resetForm() {
    Object.keys(this.refs).map(element => {
      this.refs[element].reset();
    });
    this.clearComponentState();
  }

  clearComponentState = () => {
    this.setState({
      fullName: '',
      email: '',
      phoneNumber: '',
      message: ''
    });
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/contact/components/contact_form/contact_form.jsx